import {
    Component,
    Input,
    Output,
    OnInit,
    AfterViewInit,
    EventEmitter,
} from "@angular/core";

import {
    ConsultationService,
    ConsultationProcess,
} from "../../services/consultation.service";
import { Strings } from "../../app.constants";
import { NotificationService } from "../../services/notification.service";

@Component({
    selector: "email-form-modal",
    template: `
        <div class="mod mod-modal" [class.is-open]="isVisible">
            <form class="mod-modal__dialog mod-modal__dialog--medium">
                <div class="mod-modal__content">
                    <div
                        class="zas-esign-row"
                        style="background: white; height: 20px; color: black;"
                    >
                        <p class="leader">
                            Beratungsdokumentation an diese Adresse senden:
                        </p>
                    </div>
                    <div class="zas-main-col">
                        <input
                            type="text"
                            name="email"
                            class="form-control"
                            [(ngModel)]="email"
                        />
                    </div>
                </div>
                <div class="mod-modal__footer">
                    <button
                        type="submit"
                        class="zas-button"
                        [disabled]="isSending"
                        (click)="send()"
                    >
                        <span
                            class="icon-loop spinning"
                            [style.visibility]="
                                isSending ? 'visible' : 'hidden'
                            "
                        ></span>
                        Senden
                    </button>
                    <button class="zas-button" (click)="close()">
                        Abbrechen
                    </button>
                </div>
            </form>
        </div>
    `,
    styleUrls: ["./zurich-style.css", "./zurich.css", "./main.css"],
    styles: [
        `
            .leader {
                font-weight: bold;
            }
            a {
                width: 100%;
                text-align: center;
            }
        `,
    ],
})
export class EmailFormModal {
    @Output() onClose = new EventEmitter<void>();
    cp: ConsultationProcess;
    email: string;
    isVisible = false;
    isSending = false;

    strings = Strings;
    showError = false;
    errorMessage: string;
    errorDetails: string;

    constructor(
        private consultationService: ConsultationService,
        private notify: NotificationService,
    ) {}

    public open(cp: ConsultationProcess): void {
        this.cp = cp;
        this.email = cp.Customer.Address.EMail;
        this.isVisible = true;
    }

    public close(): void {
        if (this.isVisible) {
            this.isVisible = false;
            this.showError = false;
            this.onClose.emit();
        }
    }

    public send(): void {
        this.isSending = true;
        this.consultationService.sendEmail(this.cp.Id, this.email).subscribe(
            (res) => {
                this.isSending = false;
                this.close();
            },
            (error) => {
                this.isSending = false;
                this.notify.errorExt(
                    "E-Mail",
                    "Die E-Mail konnte nicht versandt werden.",
                    error,
                );
            },
        );
    }
}
